import { ContentApiDatasource } from '../data/datasources/content-api.datasource';
import { ContentRepositoryImpl } from '../data/repositories/content.repository.impl';

const api = new ContentApiDatasource();
const repository = new ContentRepositoryImpl(api);

export const contentContainer = { repository };
